import { selectedPeriodIdsSelector, togglePeriod, updatePeriodsSelectAllState } from 'pages/candidateOffer/store';
import { OccupationItemsWithFormattedDates } from 'pages/candidateOffer/types';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { OfferItemsScheduleList, OfferSingleItemScheduleList } from '../../components';

export default function PeriodsScheduleList({ items }: { items: OccupationItemsWithFormattedDates[] }) {
    const dispatch = useDispatch();
    const selectedPeriodIds = useSelector(selectedPeriodIdsSelector);

    const handleSelectAllChange = useCallback(() => {
        dispatch(updatePeriodsSelectAllState());
    }, [ dispatch ]);

    const handleChange = useCallback((periodId: string) => {
        dispatch(togglePeriod({ periodId }));
    }, [ dispatch ]);

    if (items.length === 1) {
        return <OfferSingleItemScheduleList item={ items[0] } />;
    }

    return (
        <OfferItemsScheduleList items={ items }
            onSelectAllClick={ handleSelectAllChange }
            onSelect={ handleChange }
            translationSection="periodsPage"
            selectedIds={ selectedPeriodIds }
        />
    );
}
